<template>
  <div>

    <nav
      :class="{ 'collapse': isCollapsed}"
      class="bd-links"
    >
      <div
        v-for="n of nav"
        :key="n.root"
        v-if="!n.isHidden && isVisible(n.pages)"
        class="bd-toc-item"
        :class="{ 'active': n.isActive }"
        @click="isActive(n)"
      >
        <a
          class="bd-toc-link"
          href="#"
        >
          {{n.root}}
        </a>
        <ul class="nav bd-sidenav">
          <router-link
            exact
            tag="li"
            :to="p.url"
            v-for="p of n.pages"
            :key="p.name"
            v-if="!p.isHidden && isAllowed(p.url)"
          >
            <a href="#">
              {{p.name}}
            </a>
          </router-link>
        </ul>
      </div>

      <div class="bd-toc-item active">
        <ul class="nav bd-sidenav">
          <li>
            <a
              href="#"
              @click="privacy"
            >
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>

      <div class="bd-toc-item active">
        <ul class="nav bd-sidenav">
          <li>
            <a
              href="#"
              @click="logout"
            >
              Logout
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'nav-left',
  data() {
    return {
      searchText: '',
      isCollapsed: true,
      nav: [
        {
          root: '',
          isActive: true,
          pages: [
            { url: '/', name: 'Home' },
            { url: '/locations', name: 'Locations' },
            { url: '/users', name: 'Users' },
            { url: '/storage', name: 'Storage' },
            { url: '/contacts', name: 'Contacts' },
            { url: '/insurance', name: 'Insurance' },
            { url: '/fleet', name: 'Fleet' },
            { url: '/testdrives', name: 'Test Drive ROs' },
            { url: '/configuration', name: 'Configuration' }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters('auth', ['isAllowed'])
  },
  methods: {
    ...mapActions('auth', ['clearToken']),
    isActive(nav) {
      return true
      // todo(bwills): if nav is to large we can enable active clicks
      /*
      for (let n of this.nav) {
        n.isActive = false
      }
      nav.isActive = !nav.isActive
      this.$forceUpdate()
      */
    },
    isVisible(pages) {
      return pages.some(p => this.isAllowed(p.url))
    },
    search() {
      this.isCollapsed = false
      for (let n of this.nav) {
        n.isHidden = false
        let count = 0
        for (let p of n.pages) {
          p.isHidden = !p.name
            .toLowerCase()
            .includes(this.searchText.toLowerCase())
          if (!p.isHidden) {
            count++
          }
        }
        n.isHidden = !count
      }
      this.$forceUpdate()
    },
    logout() {
      this.clearToken()
      window.location.assign('/')
    },
    privacy() {
      window.open(
        'https://www.testdrivecopilot.com/pages/privacy-policy',
        '_blank'
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/nav-left.vue